 
import { Form } from "react-bootstrap";

export default function FormProfile(props){


    return(
        <div style={{textAlign : 'start', background:'#f1f4fa', marginTop:5, border:'1px solid rgba(0, 0, 0, 0.1)', borderRadius:'20px', padding:'10px'}}>
            <br />
            <p className='p titre-steep' style={{textAlign:'start'}}>Dites-nous en plus sur vous</p>
            <p className='p sub-titre-steep' style={{textAlign:'start'}}>Dites-nous qui vous êtes, comment les employeurs peuvent vous contacter et quelle est votre profession.</p>
            <br />
            <div className="row">

                <div className="col-sm-4" style={{textAlign: "center"}}>
                    
                    <div className="profile-info mb-5">
                      
                        {props.image != null && props.imageVisualise == null ? 
                        <img 

                            src={
                                process.env.NODE_ENV === 'production'
                                ? process.env.REACT_APP_API_BASE_URL_PROD + `/storage/images/${props.image}`
                                : process.env.REACT_APP_API_BASE_URL_LOCAL + `storage/images/${props.image}`
                            }

                            // src={`http://127.0.0.1:8000/storage/images/${props.image}`}
                            style={{borderRadius:"50%", width:'auto',height: "180px"}} alt=""/>
                    
                        : props.image != null && props.imageVisualise != null ?
                        <img src={props.imageVisualise} style={{borderRadius:"50%", width:'auto',height: "180px"}} alt="profile"/>
                        
                        :

                        <img src={`${process.env.PUBLIC_URL}/images/profile.jpg`} style={{borderRadius:"50%", width:'auto',height: "180px"}} alt="profile"/>
                        
                        }
                        
                        <input type="file" className="form-control" onChange={props.onChangeImage} /> 

                    </div>
                    
                    <p style= {{fontWeight: "900"}}>Voulez vous que votre photo soit afficher sur la page d'accueil de RIMTIC ?</p>
                    <div className='btn-radio-profile'>
                        
                        <Form.Check type="radio" label="Oui" id="option1" name="radioGroup"
                            checked={props.displayphoto == '1'}
                            value='1'
                            onChange={props.handleRadioChange}
                            style={{marginRight:3}}
                        />

                        <Form.Check type="radio" label="No" id="option2" name="radioGroup" 
                            value='0'
                            checked={props.displayphoto == '0'}
                            onChange={props.handleRadioChange}
                            style={{marginLeft:3}}
                        />

                    </div>

                
                </div>

                <div className="col-sm-8">
                    <div className="row">

                        <div className="col-md-4">
                            <span style= {{fontWeight: "900"}}>Civilite</span>
                            <Form.Select name="civilite" className="form-control" value={props.civilite} onChange={props.onChangeCivilite}>
                                <option value="">---</option>
                                <option value="Mr">Mr</option>
                                <option value="Mme">Mme</option>
                                <option value="Mme">Mlle</option>
                            </Form.Select>
                            {props.civilite === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null }
                        </div>

                        <div className="col-md-4">
                            <span style= {{fontWeight: "900"}}>Nom</span>
                            <input type="text" name="nom" className="form-control" value={props.nom} onChange={props.onChangeNom} placeholder="Nom"/>
                            {props.nom === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null }
                        </div>

                        <div className="col-md-4">
                            <span style= {{fontWeight: "900"}}>Téléphone</span> 
                            <input type="text" name="tel"  value={props.telephone} onChange={props.onChangeTelephone} className="form-control" id="phone" placeholder="Téléphone"/>
                            {props.telephone === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null}
                        </div>

                        <div className="col-md-6" style={{marginTop: "15px"}}>
                            <span style= {{fontWeight: "900"}}>Date de naissance</span>            
                        <input type="date" name="date_naissance"  value={props.dateNaissance} onChange={props.onChangeDateNaissance} max="2006-12-31" className="form-control dateNais" />
                            {props.dateNaissance === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null }
                        </div>

                        <div className="col-md-6" style={{marginTop: "15px"}}>
                            <span style= {{fontWeight: "900"}}>E-mail</span>
                            <input type="text"  value={props.email} onChange={props.onChangeEmail} className="form-control" placeholder="E-mail" readOnly/>
                         </div>

                        <div className="col-md-6" style={{marginTop: "15px"}}>
                            <span style= {{fontWeight: "900"}}>Domaine d'études</span>
                            <Form.Select  value={props.domaineEtude} onChange={props.onChangeDomaineEtude}  name="domain_d_etude" className="form-control" id="domainEtud" style={{width: "100%"}}>
                                <option value="">------------</option>
                                {props.domaines.map((domaine, index) => (
                                    <option value={domaine.nom} key={index}>{domaine.nom}</option>
                                ))}
                            </Form.Select >
                            {props.domaineEtude === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null}
                        </div>


                        <div className="col-md-6" style={{marginTop: "15px"}}>
                            <span style= {{fontWeight: "900"}}>Niveau d'études</span>
                            <Form.Select  value={props.niveau} onChange={props.onChangeNiveau} name="niveau" className="form-control" id="niveauEtude" style={{width: "100%"}}>
                                <option   >Niveau d'études</option>
                                <option value="Certificat">Certificat</option>
                                <option value="Brevet">Berevet</option>
                                <option value="BAC">BAC</option>
                                <option value="BAC+2">BAC+2</option>
                                <option value="Licence">Licence</option> 
                                <option value="BAC+4">BAC+4</option>
                                <option value="Master">Master</option>
                                <option value="Doctorat">Doctorat</option>
                                <option value="Autres">Autres</option>
                            </Form.Select>
                            {props.niveau === "" ? <p style={{fontSize:'12px', color:'red'}}>{props.msgProfile}</p> : null}
                        </div>

                        <div className="col-sm-12" style={{marginTop: "15px"}}>
                            <span style= {{fontWeight: "900"}}>À propos de moi</span>
                            <textarea  value={props.description != null ? props.description : ""} onChange={props.onChangeDescription} className="form-control" name="Apropos_Moi" id="form6Example7" rows="4" cols="54" placeholder="À propos de moi"></textarea>
                        </div>
                    </div>
                </div>

            </div>
        
        </div>
    )
}